import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import * as CC from '@chakra-ui/react'

import { Location } from 'src/types/schema/graphql'
import { mapStore } from '../../../state/mapStore'
import { handleCardHover } from '../../../utils/functions'
import mapboxgl from 'mapbox-gl'
import CardHeader from '../../../../../components/cards/CardHeader'
import CardContent from '../../../../../components/cards/CardContent'
import classNames from 'classnames'

interface MapCardProps {
    location: Location
    index: number
    popupRef: React.MutableRefObject<mapboxgl.Popup>
    mapObj: mapboxgl.Map
}

const MapCard: React.FC<MapCardProps> = ({ location, index, popupRef }) => {
    // Map Store
    const setPopupData = mapStore((state) => state.setPopupData)
    const brewCardClicked = mapStore((state) => state.brewCardClicked)
    const setBrewCardClicked = mapStore((state) => state.setBrewCardClicked)
    const hoveredLocationCard = mapStore((state) => state.hoveredLocationCard)

    const handleCardMouseEnter = () => {
        if (
            location?.title &&
            location?.slug &&
            location?.address?.geo?.lat &&
            location?.address?.geo?.lon &&
            location?.brand?.title &&
            location?.brand?.slug &&
            location?.brand?.assets
        ) {
            popupRef?.current?.remove()
            setPopupData({
                location,
            })
        }
        handleCardHover(location)
    }
    const handleMouseLeave = () => {
        if (!brewCardClicked) {
            handleCardHover(null)
            popupRef.current.remove()
        }
    }

    const handleCardClick = () => {
        setBrewCardClicked(true)
        window.open(`/brewer/${location.brand.slug}/locations/${location.slug}`, '_ blank')
    }

    return (
        <CC.Card
            className='card card--default card--location w-full cursor-pointer p-0'
            mb='4'
            onMouseEnter={handleCardMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleCardClick}
        >
            <CC.CardBody
                w='100%'
                className={classNames(
                    'duration-200 ease-in-out hover:border-transparent hover:bg-gray-50',
                    hoveredLocationCard === location.id && 'border-transparent bg-gray-50'
                )}
                p='4'
            >
                {location?.assets?.length > 0 && process.env.NEXT_PUBLIC_SHOW_LOCATION_IMAGES && (
                    <UI.Media
                        asset={location.assets[0]}
                        customClasses={'w-full h-full mb-4 rounded-md'}
                        width={350}
                        height={200}
                        alt={`Logo for ${location?.title}`}
                    />
                )}
                <CardHeader location={location} />
                <CardContent location={location} index={index} />
            </CC.CardBody>
        </CC.Card>
    )
}

export default React.memo(MapCard)
